import src from "IMAGE";
export default { src, width: 317, height: 369, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
